import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";

@Injectable()

export class ReportService {
  constructor(private authorizedService: AuthorizedService) {
  }

  /**
   * report sick through Authorized service
   * @param formData
   * @returns {Observable<R>}
   */
  reportSick(formData) {
    return this.authorizedService.post(ServiceConfig.report.reportSick, formData).map(data => {
      return data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/report.service.ts